import { observable, action } from "mobx";
import { Notification } from "../Notifications/Notification";
import WsAccessor from "../WebSockets/WsAccessor";
import moment from "moment";
import _ from "lodash";

export interface INotificationsStore {
  lastUnreadNotifications: Notification[];

  appendNotifications(items: Notification[]): void;
  appendNotification(item: Notification): void;

  markAsRead(itemId: string): void;
  markAllAsRead(): void;
  handleAllAsRead(): void;
  removeRead(itemId: string): void;
}

export class NotificationsStore implements INotificationsStore {
  @observable lastUnreadNotifications: Notification[] = [];
  accessor = new WsAccessor();

  @action.bound
  appendNotifications(notifications: Notification[]): void {
    let items = _(this.lastUnreadNotifications)
      .cloneDeep()
      .concat(notifications);
    items = _(items)
      .uniqBy("id")
      .orderBy([x => moment(x.timeString).unix()], ["desc"])
      .take(this.accessor.configuration().notifications.listSize || 10)
      .value();
    this.lastUnreadNotifications = items;
  }

  @action.bound
  appendNotification(notification: Notification): void {
    this.appendNotifications([notification]);
  }

  @action.bound
  markAsRead(notificationId: string): void {
    this.accessor.sendNotificationRead(notificationId);
  }

  @action.bound
  markAllAsRead(): void {
    this.accessor.sendAllNotificationsRead();
  }

  @action.bound
  handleAllAsRead(): void {
    this.lastUnreadNotifications = [];
  }

  @action.bound
  removeRead(notificationId: string): void {
    _.remove(this.lastUnreadNotifications, x => {
      return x.id == notificationId;
    });
  }
}
